var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#F0FDF4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 16.5,
    textAnchor: "middle",
    fill: "#22C55E",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "\u20B9")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReceived);
export default __webpack_public_path__ + "static/media/paymentReceived.929c7d075bad52db4418a959f60f033b.svg";
export { ForwardRef as ReactComponent };